import { withTheme } from '../config';
import { Slider } from '@rneui/base/dist/Slider/Slider';
export { Slider };
export default withTheme(Slider, 'Slider');
